import { KeywordFilteringGq } from '../../../graphql/projects/models/KeywordFilteringGq';

/**
 * Converts a keyword filter to query string.
 * WARNING! Not all filters are implemented.
 */
export function keywordFilterToParams(keywordFilter?: KeywordFilteringGq): string {
  let params: string[] = [];

  if (!keywordFilter) return '';

  // Tag
  keywordFilter.tagFilters?.forEach((tf, index) => {
    params.push(`tag${index}GroupId=${tf.tagGroupId}`);
    params.push(`tag${index}TagId=${tf.tagId ?? 'null'}`);
  });

  // Domain
  keywordFilter.domainRankFilters?.forEach((d, index) => {
    params.push(`domain${index}Id=${d.domainId}`);
    params.push(`domain${index}MinRank=${d.minRank ?? 'null'}`);
    params.push(`domain${index}MaxRank=${d.maxRank ?? 'null'}`);
  });

  // Serp status
  keywordFilter.serpStatusFilter?.forEach((serpFilter, index) => params.push(`serp=${serpFilter}`));

  if (!params.length) return '';
  return `?${params.join('&')}`;
}
